<div class="close-button-container">
  <mat-icon class="close-button mat-icon" aria-hidden="true" data-mat-icon-type="font" (click)="closeDetail()"
    >close</mat-icon
  >
</div>
<h2 class="social-dialog-title" mat-dialog-title>
  {{ data.modalTitle }}
</h2>
<mat-dialog-content>
  <p class="modal-text">{{ data.text }}</p>
  <p class="social-link">{{ data.socialURI }}</p>
  <div class="footer flex flex-column justify-center items-center">
    <div class="button-group">
      <button mat-button (click)="copyLink()" class="social-primary-buttons">Copy Link</button>
      <button mat-button (click)="copyInvite()" class="social-primary-buttons">Copy Invite</button>
    </div>
    <button
      id="btnIwillDoLater"
      data-testid="i-will-do-later-button"
      mat-button
      (click)="closeDetail()"
      class="social-secondary-button"
    >
      No Thanks, I’ll do it later
    </button>
  </div>
</mat-dialog-content>
